import 'core-js';
import 'url-search-params-polyfill';

import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex/dist/vuex.esm'
import App from '../vue/App.vue'
import TraveldateOffer from './modules/TraveldateOffer';
import Diverse from './modules/Diverse';
import Accommodation from './modules/Accommodation';
import Contact from './modules/Contact';
import Summary from './modules/Summary';
import { setLocale, $t } from './i18n'

const i18nPlugin = {
  install(Vue, options) {
    Vue.prototype.$t = $t
  },
}
Vue.use(i18nPlugin)

export default class Form {
    constructor(containerSelector) {
        this.containerSelector = containerSelector;
        this.config_defaults = {
            googleSiteKey: '6LeQ0TcUAAAAAOSBlHYIFoiRtuTz52yBqkMVi7x3',
        };
    }

    initVue = function (modules) {
        const that = this;
        Vue.use(Vuex);
        that.store = new Vuex.Store({
            state: {
                steps: modules,
                faClass: this.data.faClass || 'far',
                contentHeadlineTag: this.data.contentHeadlineTag || 'h2',
                contact: this.data.contact,
                subject: this.data.subject,
                siteKey: this.data.googleSiteKey,
                currentStepIndex: 0,
                isLoading: false,
                thankYouHtml: this.data.thankYouHtml,
                debug: {enabled: false, formFill: false},
                formFill: null,
                formDataSent: false,
                showNavigation: true,
                hideSidebar: typeof that.data.hideSidebar === 'undefined' ? false : that.data.hideSidebar,
                travelDate: null,
                reverseDirection: false,
                loaderText: $t('form.hint.submitting'),
                loaderClosable: false,
                menuOrder: null,
            },
            getters: {
                hideSidebar: state => {
                    return state.hideSidebar
                },
                activeStepsArray: state => {
                    return Object.values(state.steps).filter(s => s.isActive);
                },
                activeStepsCount: state => {
                    return Object.values(state.steps).filter(s => s.isActive).length;
                },
                activeStepIndex: state => {
                    const step = Object.values(state.steps)[state.currentStepIndex];
                    const activeStepsArray = Object.values(state.steps).filter(s => s.isActive);
                    return activeStepsArray.indexOf(step);
                },
                activeStepKey: state => {
                    const key_and_step = Object.entries(state.steps)[state.currentStepIndex];
                    return "step_" + key_and_step[0];
                },
                activeStep: state => {
                    const key_and_step = Object.entries(state.steps)[state.currentStepIndex];
                    return key_and_step[1];
                },
                nextStep: state => {
                    let index = state.currentStepIndex;
                    let step
                    do {
                        index++;
                        step = Object.values(state.steps)[index];
                    } while (!step.isActive);
                    return step
                },
            },
            mutations: {
                updateUserInput(state, userInput) {
                    console.log("updateUserInput", userInput);
                    state.steps[userInput.module].setUserInput(userInput.name, userInput.input);
                },
                setLoading(state, isLoading) {
                    state.isLoading = isLoading;
                },
                setDebug(state, debugData) {
                    state.debug = debugData;
                },
                setFormInputs(state, data) {
                    state.debug.formFill = true;
                    state.formFillData = data;
                },
                resetFormInputs(state) {
                    state.debug.formFill = false;
                    state.formFillData = null;
                },
                toggleNavigation(state, showNavigation) {
                    state.showNavigation = showNavigation;
                },
                setTravelDate(state, travelDate) {
                    state.travelDate = travelDate;
                },
                setNextStep(state) {
                    // console.log("Summary", Object.values(state.steps).map(s => s.debugSummaryString()))
                    state.reverseDirection = false;
                    let step;
                    do {
                        state.currentStepIndex++;
                        step = Object.values(state.steps)[state.currentStepIndex];
                    } while (!step.isActive);
                    that.scrollToElement();
                },
                setLastStep(state) {
                    state.reverseDirection = true;
                    let step;
                    do {
                        state.currentStepIndex--;
                        step = Object.values(state.steps)[state.currentStepIndex];
                    } while (!step.isActive);
                    that.scrollToElement();
                },
                resetStep(state) {
                    state.currentStepIndex = 0;
                },
                reverseDirection(state, rd) {
                    state.reverseDirection = rd;
                },
                setFormAsSent(state) {
                    state.formDataSent = true;
                    that.scrollToElement();
                },
                setLoaderText(state, options) {
                    if(options.append) {
                        state.loaderText += "\n" + options.text;
                    } else {
                        state.loaderText = options.text;
                    }
                },
                setLoaderClosable(state, closable) {
                    state.loaderClosable = closable;
                },
                menuOrder(state, value) {
                    state.menuOrder = value;
                }
            },
        });
        Vue.mixin({
            methods: {
                moduleExists: function (name) {
                    return typeof modules[name] !== 'undefined';
                }
            }
        });
        document.addEventListener('DOMContentLoaded', () => {
            const m = document.querySelector(that.containerSelector);
            const store = that.store;
            m.appendChild(document.createElement('app'));
            that.app = new Vue({
                store,
                el: this.containerSelector + ' > app',
                components: {App},
            });
        });
        window.onbeforeunload = function (e) {
            if (that.store.state.currentStepIndex > 0 && !that.store.state.formDataSent) {
                e.preventDefault();
                const msg = "Sie haben Ihre Nachricht noch nicht abgesendet";
                // Chrome requires returnValue to be set
                e.returnValue = msg;
                // msg will be shown at least in IE
                return msg;
            } else {
                delete e['returnValue'];
            }
        };

    };
    parseConfig = function () {
        let modules = {};
        const stepsSlugToTitle = {}
        this.data.steps.forEach( s => stepsSlugToTitle[s.slug] = s.title )
        this.data.steps.forEach((step_config, index) => {
            switch (step_config.module) {
                case 'diverse':
                    modules[step_config.module] = new Diverse(step_config.title, index, step_config.tdoDescription, step_config.options, step_config.showInTraveldateOffer, step_config.keepActiveAfterTraveldateOffer, this.data.checkin, this.data.checkout);
                    break;
                case 'traveldateoffer':
                    modules[step_config.module] = new TraveldateOffer(step_config.title, index, step_config.offers, step_config.firstQuestion, this.data.checkin, this.data.checkout, step_config.min_nights, stepsSlugToTitle);
                    break;
                case 'accommodation':
                    modules[step_config.module] = new Accommodation(step_config.title, index, step_config.categories, step_config.services, step_config.firstQuestion);
                    break;
                case 'contact':
                    modules[step_config.module] = new Contact(step_config.title, index, step_config.mandatory, step_config.firstQuestion);
                    break;
                case 'summary':
                    modules[step_config.module] = new Summary(step_config.title, index, step_config.dataProcessingConsentText, step_config.dataProtectionUrl);
                    break;
                default:
                    console.error("unknown module: ", step_config.module)
            }
        });
        return modules;
    };
    /*
    isMobile = function () {
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));
    };
    */
    scrollToElement = function () {
        const element = document.getElementById("manetform_v6");
        const rect = element.getBoundingClientRect();
        let overlayHeight = 115;
        window.scrollBy({
            top: rect.y - overlayHeight,
            left: 0,
            behavior: 'smooth'
        });
    };
    setDebugTrigger = function () {
        const that = this;
        const el = document.getElementById("manetform_v6");

        el.addEventListener("passMenuOrder",  (e) => {
            this.store.commit('menuOrder', e.detail);
        }, false)

        el.addEventListener("triggerDebug", function (e) {
            that.store.commit('setDebug', {
                enabled: e.detail.enabled,
            });
        }, false);

        el.addEventListener("triggerFill", function (e) {
            let payload = false;
            if (typeof e.detail == 'object') {
                payload = {
                    email: e.detail.email,
                    firstName: e.detail.firstName,
                    lastName: e.detail.lastName,
                    salutation: e.detail.salutation,
                }
            }
            that.store.commit('setFormInputs', payload);
        }, false);

        el.addEventListener("triggerThankYou", function (e) {
            that.store.state.steps.summary.renderThankYou = e.detail.thankYou;
            that.store.state.currentStepIndex = e.detail.thankYou ? Object.keys(that.store.state.steps).length - 1 : 0;
            that.store.commit('toggleNavigation', !that.store.state.showNavigation);
        }, false);
    };

    showBrowserHint = function () {
        const overlay = document.getElementsByClassName('browser-hint-js');
        overlay[0].className = 'display-4';
        // overlay[0].classList.remove('d-none');
    };

    init() {
        const touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (document.documentElement.classList === undefined) {
            this.showBrowserHint();
            return false;
        }
        if (!touchsupport) { // browser doesn't support touch
            document.documentElement.classList.add("non-touch")
        } else {
            document.documentElement.classList.add("can-touch")
        }
        const c = document.querySelector(this.containerSelector);
        if (c.dataset === undefined) {
            this.showBrowserHint();
            return false;
        }
        const config = JSON.parse(c.dataset.config);
        this.data = Object.assign(this.config_defaults, config);
        setLocale(config.locale)
        this.initVue(this.parseConfig());
        this.setDebugTrigger();
    };
};
